import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { LastRoundHighsSlider } from './components/LastRoundHighsSlider';
import { getTranslation } from '../../../../../../common/react/utils/translations';
import { ToggleInput } from '../../../../../../common/react/components/ToggleInput';

import {
    useGetLeadingPlayerMatchRoundTotalsQuery,
    useGetLeadingPlayerMatchSeasonTotalsQuery
} from '../../../../store/js/modules/api/statsPro-api';

const { DateTime } = luxon;

export const LastRoundHighs = ({
    seasonId,
    compseasonId,
    currentRound,
    roundSubtitle,
    seasonSubtitle,
    roundName
}) => {
    const [lastCompletedRound, setlastCompletedRound] = useState(
        Number(currentRound)
    );

    const [activeSlider, setActiveSlider] = useState('round');
    const toggleActiveSlider = (type) => setActiveSlider(type);
    const translations = {
        lastRound: getTranslation('label.statspro.lastRound'),
        round: getTranslation('label.statspro.round'),
        highs: getTranslation('label.statspro.highs'),
        season: getTranslation('label.statspro.season')
    };

    let compSeasonData = {};

    const [statsObj, setStatsObj] = useState({});

    const { data: roundData } = useGetLeadingPlayerMatchRoundTotalsQuery(
        statsObj.roundId,
        { skip: !statsObj.roundId }
    );
    const { data: seasonData } = useGetLeadingPlayerMatchSeasonTotalsQuery(
        statsObj.seasonId,
        { skip: !statsObj.seasonId }
    );

    const fetchLastRoundHighsData = (round) => {
        const roundsData = compSeasonData.rounds[round - 1];

        if (
            roundsData &&
            DateTime.fromISO(roundsData.utcEndTime) < DateTime.utc()
        ) {
            setlastCompletedRound(round);
            setStatsObj({
                roundId: roundsData.providerId
            });
        } else if (round > 1) {
            fetchLastRoundHighsData(round - 1);
        }
    };

    useEffect(() => {
        fetch(`${PULSE.app.environment.api}compseasons/${compseasonId}`)
            .then((response) => response.json())
            .then((responseData) => {
                compSeasonData = responseData.compSeasons[0];
                fetchLastRoundHighsData(lastCompletedRound);
            });
    }, []);

    useEffect(() => {
        if (activeSlider === 'season' && !seasonData) {
            setStatsObj({
                seasonId: seasonId
            });
        }
    }, [activeSlider]);

    return (
        <>
            <div className={'last-round-highs__header'}>
                <div className={'last-round-highs__toggle'}>
                    <span className={'last-round-highs__toggle-divider'}></span>
                    <ToggleInput
                        id="data-type-toggle"
                        value={activeSlider}
                        onChange={(type) => toggleActiveSlider(type)}
                        options={[
                            {
                                label: translations.lastRound,
                                value: 'round'
                            },
                            {
                                label: translations.season,
                                value: 'season'
                            }
                        ]}
                    />
                    <span className={'last-round-highs__toggle-divider'}></span>
                </div>
                <div
                    className={classNames(
                        'last-round-highs__heading-container',
                        {
                            'is-active': activeSlider === 'round'
                        }
                    )}
                >
                    <h2 className={'last-round-highs__title'}>
                        {roundName} {translations.highs}
                    </h2>
                    {roundSubtitle !== '' && (
                        <p className={'last-round-highs__subtitle'}>
                            {roundSubtitle}
                        </p>
                    )}
                </div>
                <div
                    className={classNames(
                        'last-round-highs__heading-container',
                        {
                            'is-active': activeSlider === 'season'
                        }
                    )}
                >
                    <h2 className={'last-round-highs__title'}>
                        {translations.season} {translations.highs}
                    </h2>
                    {seasonSubtitle !== '' && (
                        <p className={'last-round-highs__subtitle'}>
                            {seasonSubtitle}
                        </p>
                    )}
                </div>
            </div>
            <div
                className={classNames(
                    'last-round-highs__slider stats-slider fade-in-on-load',
                    {
                        'is-loaded': !!roundData,
                        'is-active': activeSlider === 'round'
                    }
                )}
            >
                <LastRoundHighsSlider data={roundData} type={'round'} />
            </div>
            <div
                className={classNames(
                    'last-round-highs__slider stats-slider fade-in-on-load',
                    {
                        'is-loaded': !!seasonData,
                        'is-active': activeSlider === 'season'
                    }
                )}
            >
                <LastRoundHighsSlider data={seasonData} type={'season'} />
            </div>
        </>
    );
};

LastRoundHighs.propTypes = {
    seasonId: PropTypes.string.isRequired,
    compseasonId: PropTypes.string.isRequired,
    currentRound: PropTypes.string.isRequired,
    roundSubtitle: PropTypes.string,
    seasonSubtitle: PropTypes.string,
    roundName: PropTypes.string
};
